import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import InfoBar from '../../components/Navigation/InfoBar';
import * as ROUTES from '../../constants/routes';
import useApi from '../../hooks/use-api';
import { useUser } from '../../hooks/use-user';
import CompaniesOverview from '../../components/Tables/Companies/CompaniesOverview';

function CompaniesListPage() {
	const navigate = useNavigate();
	const { setCompany } = useUser();

	const [body, setBody] = useState([]);
	const [{ data }] = useApi.get(ROUTES.COMPANIES, { archived: false }, { cachePolicy: 'no-cache' });

	useEffect(() => {
		if (data) {
			setBody(data);
		}
	}, [data]);

	/*
	 * This creates a warning in browser console because updating the dationUser causes a re-render
	 * When re rendering the router also unmounts and mount this component again which cause the warning
	 * Can't find out how to remove warning but this is necessary so we keep it for now as it doesn't break something
	 */
	useEffect(() => {
		setCompany(null);
	}, []);

	return (
		<>
			<InfoBar />
			<div className="d-flex flex-row-reverse">
				<Button
					id="import-company"
					variant="outline-secondary"
					className="rounded-button p-1"
					type="button"
					onClick={() => navigate(ROUTES.IMPORT_COMPANY)}>
					<span
						className="glyphicons glyphicons-square-download"
						style={{ position: 'relative', top: 3 }}
					/>
				</Button>
			</div>
			<div className="row pb-5">
				<div className="col-12 col-xl-10 mx-auto pt-n5">
					<CompaniesOverview
						companies={body}
						handleRowClick={(original) => navigate(ROUTES.companyPage(original.id))}
					/>
				</div>
			</div>
		</>
	);
}

export default CompaniesListPage;
